import { useSelector } from 'store';

const useIsLoggedIn = () => useSelector((state) => state.auth.isLoggedIn);

export default useIsLoggedIn;
